<div style="width: 100%; display: flex; justify-content: flex-end;">
  <span (click)="openChangeLog()" style="padding: 12px; font-size: 12px; color: rgba(0,0,0,0.4); cursor: pointer">
    v. 4.1.1
  </span>
</div>
